// Cart Jetter Compatibility Handler
document.addEventListener('DOMContentLoaded', function() {
  initCartJetterCompatibility();
});

function initCartJetterCompatibility() {
  // Helper function to parse GID and extract product ID
  function getProductIdFromGid(gid) {
    // If gid is an object with an id property, use that id
    if (typeof gid === 'object' && gid !== null && gid.id) {
      return String(gid.id);
    }
    
    // Handle string GID format
    if (typeof gid === 'string') {
      // Handle full GID (gid://shopify/Product/123)
      const fullGidPattern = /gid:\/\/shopify\/Product\/(\d+)/;
      const match = gid.match(fullGidPattern);
      return match ? match[1] : gid; // Return the ID or the original string if not a GID
    }
    
    // Return null for any other case
    return null;
  }
  
  // Function to extract all product IDs from a GID array
  function extractProductIdsFromGids(gidArray) {
    if (!Array.isArray(gidArray)) return [];
    return gidArray.map(getProductIdFromGid).filter(id => id !== null);
  }
  
  // Helper function to safely stringify any value
  function safeStringify(value) {
    if (value === null) return 'null';
    if (value === undefined) return 'undefined';
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch (e) {
        return String(value);
      }
    }
    return String(value);
  }
  
  // Find all cart items with compatibility data
  const cartItems = document.querySelectorAll('.cart-item[data-compat-just-right]');
  if (!cartItems.length) return;
  
  console.log('Found ' + cartItems.length + ' cart items with compatibility data');
  
  // Process each cart item
  cartItems.forEach(cartItem => {
    // Parse compatibility data from data attributes
    try {
      // First get raw values for debugging
      const justRightRaw = cartItem.getAttribute('data-compat-just-right');
      console.log('Just Right Raw: ' + cartItem.getAttribute('data-compat-just-right'));
      const tooBigRaw = cartItem.getAttribute('data-compat-too-big');
      const tooSmallRaw = cartItem.getAttribute('data-compat-too-small');
      
      console.log('Raw compatibility data:', {
        justRight: justRightRaw,
        tooBig: tooBigRaw,
        tooSmall: tooSmallRaw
      });
      
      // Parse the JSON safely
      const justRightList = JSON.parse(justRightRaw || '[]');
      const tooBigList = JSON.parse(tooBigRaw || '[]');
      const tooSmallList = JSON.parse(tooSmallRaw || '[]');
      const selectedMachineId = cartItem.dataset.selectedMachine || '';
      
      console.log('Parsed compatibility data:', {
        justRightList,
        tooBigList,
        tooSmallList,
        selectedMachineId
      });
      
      // Extract product IDs from GIDs for easier comparison
      const compatibleIds = extractProductIdsFromGids(justRightList);
      const tooBigIds = extractProductIdsFromGids(tooBigList);
      const tooSmallIds = extractProductIdsFromGids(tooSmallList);
      
      console.log('Extracted IDs:', {
        justRightList,
        compatibleIds,
        tooBigIds,
        tooSmallIds
      });
      
      console.log('Compatible IDs:', compatibleIds);

      // Update the display in debug section
      updateDebugDisplay(cartItem, justRightList, tooBigList, tooSmallList);
      
      // Find the machine dropdown
      const machineSelect = cartItem.querySelector('.cart-item-jetter-machine__select');
      if (!machineSelect) {
        console.warn('Machine select not found in cart item');
        return;
      }
      
      // Set up the machine dropdown
      setupJetterDropdown(machineSelect, cartItem, compatibleIds, tooBigIds, tooSmallIds, selectedMachineId);
      
    } catch (error) {
      console.error('Error processing cart item compatibility:', error);
    }
  });
  
  // Update the debug display with proper product IDs
  function updateDebugDisplay(cartItem, justRightList, tooBigList, tooSmallList) {
    // Update the lists containers using the new data-compat-section attributes
    console.log('Just Right List: ' + justRightList);
    console.log('Too Big List: ' + tooBigList);
    console.log('Too Small List: ' + tooSmallList);

    updateMetafieldSection(cartItem, '[data-compat-section="just-right"]', justRightList);
    updateMetafieldSection(cartItem, '[data-compat-section="too-big"]', tooBigList);
    updateMetafieldSection(cartItem, '[data-compat-section="too-small"]', tooSmallList);
    
    // Also update the debug raw sections
    updateRawDebugDisplay(cartItem);
  }
  
  // Update raw debug display
  function updateRawDebugDisplay(cartItem) {
    // Find each debug raw span and update with formatted content
    const rawElements = cartItem.querySelectorAll('[data-debug-raw]');
    rawElements.forEach(element => {
      const type = element.getAttribute('data-debug-raw');
      const value = element.textContent;
      
      // Try to parse and format JSON
      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          // Format each item for better readability
          element.innerHTML = parsed.map(item => {
            // Check if item is an object
            if (typeof item === 'object' && item !== null) {
              return '<code>' + item.id + "-" + item.title + '</code>';
            }
            // Highlight IDs in GIDs
            else if (typeof item === 'string' && item.includes('gid://shopify/Product/')) {
              const productId = getProductIdFromGid(item);
              return item.replace(productId, `<span style="color:#c00;font-weight:bold">${productId}</span>`);
            }
            return item;
          }).join('<br>');
        } else if (typeof parsed === 'object' && parsed !== null) {
          element.innerHTML = '<code>' + parsed + '</code>';
        }
      } catch (e) {
        // If parsing fails, keep original
        console.warn(`Failed to parse ${type} value:`, e);
      }
    });
  }
  
  // Update a specific metafield section in the debug display
  function updateMetafieldSection(cartItem, sectionSelector, gidList) {
    const section = cartItem.querySelector(sectionSelector);
    if (!section) return;
    
    // Clear existing items
    section.innerHTML = '';
    
    // If empty list, show empty message
    if (!Array.isArray(gidList) || gidList.length === 0) {
      const emptyItem = document.createElement('li');
      emptyItem.className = 'empty-list';
      emptyItem.textContent = 'Empty (No products in this category)';
      section.appendChild(emptyItem);
      return;
    }
    
    // Add each GID as a list item
    gidList.forEach(gid => {
      const productId = getProductIdFromGid(gid);
      
      const item = document.createElement('li');
      item.setAttribute('data-id', productId);
      
      // Check if gid is an object
      if (typeof gid === 'object' && gid !== null) {
        // Create a formatted display of the object
        item.innerHTML = '<code>' + gid.id + "-" + gid.title + '</code>';
      }
      // Create a formatted display of the GID with highlighted ID
      else if (typeof gid === 'string' && gid.includes('gid://shopify/Product/')) {
        // Extract parts from GID for formatted display
        const parts = gid.split('/');
        const type = parts[3] || 'Product';
        const id = parts[4] || productId;
        
        item.innerHTML = `<span style="color:#999">gid://shopify/${type}/</span><strong>${id}</strong>`;
      } else {
        // For non-GID format, just display the value
        item.textContent = gid;
      }
      
      section.appendChild(item);
    });
  }
  
  // Set up the jetter machine dropdown
  function setupJetterDropdown(select, cartItem, compatibleIds, tooBigIds, tooSmallIds, initialSelectedId) {
    // Initialize dropdown display
    const dropdown = select.closest('[data-jetter-dropdown]');
    if (!dropdown) return;
    
    const displayValue = dropdown.querySelector('.cart-item-jetter-machine__value');
    const badge = cartItem.querySelector('[data-compatibility-badge]');
    
    // Set initial selection and badge
    if (initialSelectedId) {
      // Find the option matching the initial ID
      for (let i = 0; i < select.options.length; i++) {
        const option = select.options[i];
        const optionId = option.getAttribute('data-product-id');
        
        // Check if this option matches the selected ID
        if (optionId === initialSelectedId) {
          select.selectedIndex = i;
          if (displayValue) {
            displayValue.textContent = option.textContent;
          }
          break;
        }
      }
      
      // Show initial compatibility status
      updateCompatibilityStatus(badge, initialSelectedId, compatibleIds, tooBigIds, tooSmallIds);
      
      // Update debug highlights
      updateDebugHighlights(cartItem, initialSelectedId);
      
      // Update selected machine ID in debug view
      updateSelectedMachineId(cartItem, initialSelectedId);
    }
    
    // Handle change events
    select.addEventListener('change', function() {
      const selectedOption = select.options[select.selectedIndex];
      const selectedMachineId = selectedOption.getAttribute('data-product-id');
      
      console.log('Selected machine changed:', selectedMachineId);
      
      // Update display value
      if (displayValue) {
        displayValue.textContent = selectedOption.textContent;
      }
      
      // Update machine ID hidden input
      updateHiddenInput(cartItem, selectedMachineId);
      
      // Update compatibility badge
      updateCompatibilityStatus(badge, selectedMachineId, compatibleIds, tooBigIds, tooSmallIds);
      
      // Update debug display highlights
      updateDebugHighlights(cartItem, selectedMachineId);
      
      // Update selected machine ID in debug view
      updateSelectedMachineId(cartItem, selectedMachineId);
    });
  }
  
  // Update the hidden input for the line item properties
  function updateHiddenInput(cartItem, machineId) {
    let hiddenInput = cartItem.querySelector('input[name="properties[machine-product-id]"]');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[machine-product-id]';
      cartItem.appendChild(hiddenInput);
    }
    hiddenInput.value = machineId || '';
  }
  
  // Update the compatibility badge status
  function updateCompatibilityStatus(badge, selectedMachineId, compatibleIds, tooBigIds, tooSmallIds) {
    if (!badge) return;
    
    let isCompatible = false;
    let statusMessage = '';
    
    if (selectedMachineId) {
      console.log('Checking compatibility for machine ID:', selectedMachineId);
      console.log('Compatible IDs:', compatibleIds);
      console.log('Too big IDs:', tooBigIds);
      console.log('Too small IDs:', tooSmallIds);
      
      // Check if the selected machine ID matches any ID in the lists
      if (compatibleIds.includes(selectedMachineId)) {
        isCompatible = true;
        statusMessage = 'Machine Compatible';
        console.log('Machine is compatible');
      } else if (tooBigIds.includes(selectedMachineId)) {
        statusMessage = 'Too Large For Machine';
        console.log('Machine is too big');
      } else if (tooSmallIds.includes(selectedMachineId)) {
        statusMessage = 'Too Small For Machine';
        console.log('Machine is too small');
      } else {
        statusMessage = 'Machine Incompatible';
        console.log('Machine compatibility unknown');
      }
    }
    
    // Update badge classes and text
    if (isCompatible) {
      badge.classList.add('compatible');
      badge.classList.remove('incompatible');
    } else {
      badge.classList.add('incompatible');
      badge.classList.remove('compatible');
    }
    
    // Make sure badge is visible
    badge.style.display = 'inline-flex';
    
    const badgeText = badge.querySelector('span');
    if (badgeText) {
      badgeText.textContent = statusMessage;
    }
    
    // Animate the badge
    badge.style.transition = 'all 0.3s';
    badge.style.transform = 'scale(1.05)';
    setTimeout(() => {
      badge.style.transform = 'scale(1)';
    }, 300);
  }
  
  // Update highlighting in the debug display
  function updateDebugHighlights(cartItem, selectedMachineId) {
    const allListItems = cartItem.querySelectorAll('.metafield-list li[data-id]');
    allListItems.forEach(item => {
      if (item.getAttribute('data-id') === selectedMachineId) {
        item.classList.add('highlight');
      } else {
        item.classList.remove('highlight');
      }
    });
  }
  
  // Update the selected machine ID in the debug view
  function updateSelectedMachineId(cartItem, selectedMachineId) {
    // Update the selected machine ID in the raw debug section
    const machineIdElement = cartItem.querySelector('[data-debug-raw="selected-machine"]');
    if (machineIdElement) {
      machineIdElement.textContent = selectedMachineId || 'None';
    }
    
    // Also update compatibility status in debug view
    const statusElement = cartItem.querySelector('.compatibility-status');
    if (statusElement && selectedMachineId) {
      // Get the list items with this machine ID
      const justRightItems = cartItem.querySelectorAll('[data-compat-section="just-right"] li[data-id="' + selectedMachineId + '"]');
      const tooBigItems = cartItem.querySelectorAll('[data-compat-section="too-big"] li[data-id="' + selectedMachineId + '"]');
      const tooSmallItems = cartItem.querySelectorAll('[data-compat-section="too-small"] li[data-id="' + selectedMachineId + '"]');
      
      let statusMessage = 'Unknown';
      
      // Check each list for the selected machine ID
      if (justRightItems.length > 0) {
        statusMessage = 'Just right (Compatible)';
      } else if (tooBigItems.length > 0) {
        statusMessage = 'Too large (Incompatible)';
      } else if (tooSmallItems.length > 0) {
        statusMessage = 'Too small (Incompatible)';
      }
      
      statusElement.textContent = statusMessage;
      statusElement.style.fontWeight = 'bold';
      statusElement.style.backgroundColor = '#fffde7';
      setTimeout(() => {
        statusElement.style.backgroundColor = '';
      }, 500);
    }
  }
} 